export default __webpack_public_path__ + "static/media/whatDoIDo_icon_1.104e18cf.svg";